<div class="modal-header">
  <h3 class="modal-title">{{ contentConfig.textsKey + 'Title' | translate }}</h3>
  <button type="button" class="close" data-cy="CloseModal" (click)="activeModal.dismiss(actionTypes.CANCEL)">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <p>{{ contentConfig.textsKey + 'Question' | translate: contentConfig.questionParams }}</p>
</div>
<div class="modal-footer">
  @for (c of choices; track c) {
    <button
      type="button"
      class="btn btn-primary"
    (click)="output.emit(c)">{{ c.label | translate }}</button>
  }
</div>
